import { useTranslation } from 'react-i18next'

import { getEntityProfileTabs } from '../../../Entity'
import { Skeleton } from '../../../Skeleton'
import { TabScrollList } from '../../../Tab'
import {
  useViewingProfileContext,
  useViewingProfileTabsActiveTab,
} from '../RentalPortalViewingProfile.hooks'

import { VIEWING_PROFILE_TAB_LIST } from './RentalPortalViewingProfileTabs.constants'

import * as styles from './RentalPortalViewingProfileTabs.module.css'

function RentalPortalViewingProfileTabs() {
  const { t } = useTranslation()

  const { isInitiated, viewingData } = useViewingProfileContext()

  const preparedTabs = getEntityProfileTabs({
    entityData: viewingData,
    t,
    tabs: VIEWING_PROFILE_TAB_LIST,
  })

  const { activeTabId, handleSetActiveTab } = useViewingProfileTabsActiveTab({
    preparedTabs,
    viewingData,
  })

  const ActiveTabContent = VIEWING_PROFILE_TAB_LIST.find(
    tab => tab.id === activeTabId
  )?.Content

  return isInitiated ? (
    <>
      <TabScrollList
        activeTab={activeTabId}
        preparedTabs={preparedTabs}
        wrapperClassName={styles.tabsWrapper}
        onSetActiveTab={handleSetActiveTab}
      />
      {ActiveTabContent ? <ActiveTabContent /> : null}
    </>
  ) : (
    <Skeleton className={styles.skeleton} />
  )
}

export default RentalPortalViewingProfileTabs
